import React from 'react';
import { Link } from 'react-router-dom';
import './Training.css';
import { PageTitle } from '../../components';
import { training } from '../../constants'; 
import { FaArrowRight, FaClock} from 'react-icons/fa';

const Training = () => {
    return (
        <>
            <PageTitle title={'Oferta Szkoleniowa'} page={'Szkolenia'} />

            <section className='training-list-section'>
                <div className='training-grid'>
                    {training.map((item) => (
                        <div key={item.id} className='training-card'>
                            
                            {/* Obrazek karty */}
                            <div className='card-image'>
                                <img src={item.image} alt={item.title} />
                                <div className='card-category'>{item.details.level}</div>
                            </div>

                            {/* Treść karty */}
                            <div className='card-content'>
                                <h3 className='card-title'>{item.title}</h3>
                                <p className='card-desc'>
                                    {item.subtitle.substring(0, 100)}...
                                </p>
                                
                                <div className='card-meta'>
                                    <span><FaClock /> {item.details.duration}</span>
                                </div>

                                <Link to={`/Szkolenia/${item.id}`} className='btn-details'>
                                    Szczegóły <FaArrowRight className='icon-arrow' />
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </>
    );
};

export default Training;